module.exports = __webpack_public_path__ + "img/7740b9c.jpg";